document.addEventListener('DOMContentLoaded', function () {
  let stickyEl = document.querySelector('.collection-toolbar');
  let sentinel = document.querySelector('.sentinel-sticky');

  function getStickyOffset() {
    let offset = 0;

    const announcementBar = document.querySelector('#announcement-bar');
    const header = document.querySelector('header');

    if (announcementBar) {
      offset += announcementBar.offsetHeight;
    }

    if (header) {
      offset += header.offsetHeight;
    }

    return offset;
  }

  function checkStickyState() {
    // Update references when filters change or content is updated dynamically
    stickyEl = document.querySelector('.collection-toolbar');
    sentinel = document.querySelector('.sentinel-sticky');

    if (!stickyEl || !sentinel) return;

    const sentinelRect = sentinel.getBoundingClientRect();
    const stickyOffset = getStickyOffset();

    if (sentinelRect.bottom <= stickyOffset) {
      stickyEl.classList.add('is-sticky');
    } else {
      stickyEl.classList.remove('is-sticky');
    }
  }

  checkStickyState();

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        checkStickyState();
        ticking = false;
      });
      ticking = true;
    }
  });

  window.addEventListener('resize', checkStickyState);
});
